/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import Vue from 'vue'
import filter from 'lodash/filter'
import findIndex from 'lodash/findIndex'

export default {
  setToken (state, token) {
    state.token = token
  },
  setCustomer (state, customer) {
    customer && customer.addresses && customer.addresses.length && customer.addresses.forEach(addr => {
      addr.country_id = addr.country_code
    })
    state.current = customer
  },
  setAddress (state, address) {
    address.country_id = address.country_code

    if (!state.current.addresses) {
      state.current.addresses = []
    }
    let addresses = [...state.current.addresses]
    if (addresses) {
      var i = 0
      for (;i < addresses.length; i++) {
        if (addresses[i].id === address.id) {
          addresses[i] = address
          i = addresses.length + 1
        }
      }
      if (i === addresses.length) {
        addresses.push(address)
      }
      state.current = { ...state.current, ...{ addresses } }
    }
  },
  deleteAddress (state, id) {
    let addresses = state.current.addresses.filter(addr => addr.id !== id)
    state.current = { ...state.current, ...{ addresses } }
  },
  setGuest (state, guest) {
    if (guest) {
      state.guest = guest
    } else {
      state.guest = {
        email: '',
        wishlist: {
          items: [],
          sharingCode: ''
        }
      }
    }
  },
  guestSetWishlistShareCode (state, sharingCode) {
    state.guest.wishlist.sharing_code = sharingCode
  },
  guestSetWishlistItem (state, items) {
    state.guest.wishlist.items = items
  },
  guestAddWishlistItem (state, item) {
    state.guest.wishlist.items.push({ ...item })
  },
  guestRemoveWishlistItem (state, items) {
    state.guest.wishlist.items = items
  },
  updateWishlistItem (state, { item }) {
    let listItems
    if (state.current && state.current.wishlist) {
      listItems = state.current.wishlist.items
    } else {
      listItems = state.guest.wishlist.items
    }
    let index = findIndex(listItems, { id: item.id })
    Vue.set(listItems, index, item)
  },
  removeItemWishlist (state, itemId) {
    let current = state.current
    if (current && current.wishlist && current.wishlist.items.length) {
      current.wishlist.items = filter(current.wishlist.items, item => item.id !== itemId)
    } else {
      state.guest.wishlist.items = filter(state.guest.wishlist.items, item => item.id !== itemId)
    }
  },
  newUser (state, status) {
    state.newUser = status
  },
  setIp (state, ip) {
    state.ip = ip
  }
}
